<template>
  <div class="jo_index">
      <div class="jo_header">
          <van-image width="4.2rem" height="5.28rem" :src="url||'https://oss.mcloud.moveclub.cn/mpms/20210311/1615428580-60497be4841e7.png'" />
      </div>
      <div :class="[type===1?'jo_footer':'jo_footer1']">
          <UploadImage v-if="!show" class="jo_up" :item="item" @setUrl="setUrl" />
          <div v-else class="sigu" @click="signup"></div>
      </div>
  </div>
</template>
<script>
import { Image, Popup } from "vant";
import UploadImage from "@/components/UploadImage/index";

export default {
  components: {
    VanImage: Image,
    Popup,
    UploadImage
  },
  name: "hpJoin",
  computed: {
  },
  data() {
    return {
      item:{
          num:1,
          style:true
      },
      url: '',
      show: false,
      type: 1
    };
  },
  methods: {
    init: function () {
    },
    setUrl(res) {
      let data = JSON.parse(res)
      console.log(data)
        this.url = data[0]
        // console.log(this.url,11)
        this.show = true
    },
    signup() {
      if(this.url==''){
        this.$toast.fail('请上传图片');
        return;
      }
      if(+this.$route.params.type===1){
        this.$api.activity.hpSup({matchid:this.$route.params.matchid,url:this.url}).then((res)=>{
          if(res.status*1===200){
            this.$toast.success('上传成功');
            this.$router.replace({name:'hp_activity', params: {matchid:this.$route.params.matchid}})
          }
        })
      }else{
        this.$api.activity.hpGroupUp({matchid:this.$route.params.matchid,url:this.url}).then((res)=>{
          if(res.status*1===200){
            this.$toast.success('上传成功');
            this.$router.replace({name:'hp_group', params: {matchid:this.$route.params.matchid}})
          }
        })
      }

    }
  },
  mounted() {
    this.$nextTick(() => {
    //   this.init();
      this.type = this.$route.params.type*1
    });
  },
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>

